/* eslint-disable react/jsx-props-no-spreading */
import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import i18n from 'i18next';
import AutoAwesomeOutlined from '@mui/icons-material/AutoAwesomeOutlined';
import Loop from '@mui/icons-material/Loop';

import { Button } from 'uikit/buttons';

import AiGenerateButtonWrapper from './aiGenerateButtonWrapper';

import styles from '../styles/aiGenerateButton.module.scss';

const getButtonContent = ({ content, isGenerating }) => {
  if (isGenerating) {
    return (
      <>
        <Loop
          className={classNames(styles.icon, styles.generating)}
          sx={{ height: 18, width: 18 }}
        />
        {content}
      </>
    );
  }

  return (
    <>
      <AutoAwesomeOutlined className={styles.icon} sx={{ height: 18, width: 18 }} />
      {content}
    </>
  );
};

const AiGenerateButton = ({
  isGenerating,
  onClick,
  className = '',
  content = i18n.t('suggest'),
  disabledText = '',
  isDisabled = false,
}) => {
  const ref = useRef();

  return (
    <AiGenerateButtonWrapper disabledText={disabledText} isDisabled={isDisabled} ref={ref}>
      <Button
        className={classNames(styles.button, className)}
        isDisabled={isGenerating || isDisabled}
        variant="outlined"
        onClick={onClick}
      >
        {getButtonContent({ content, isGenerating })}
      </Button>
    </AiGenerateButtonWrapper>
  );
};

AiGenerateButton.propTypes = {
  className: PropTypes.string,
  content: PropTypes.string,
  disabledText: PropTypes.string,
  isDisabled: PropTypes.bool,
  isGenerating: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default AiGenerateButton;
